import React from "react";
import { Accordion, Alert, Button, Card, Form } from "react-bootstrap";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import MarkDownEditor from "../../../../components/markdownEditor/MarkDownEditor";
import Switch from "react-switch";
import "./InstanceTemplateDialog.css";
import TagSelection from "../../../../components/tagSelection/TagSelection";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";

class InstanceTemplateDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      name: {
        defaultValue: "",
        initValid: false,
        rule: ValidationHelper.isNonEmptyString
      },
      description: {
        defaultValue: ValidationHelper.getDefaultValueExtendedDescription(),
        initValid: false,
        rule: ValidationHelper.isNonEmptyExtendedDescription
      },
      preferredNetworkProfile: {
        defaultValue:
          this.props.instanceTemplate?.preferredNetworkProfile || null,
        initValid: true,
        rule: ValidationHelper.isOptionalID
      },
      infrastructureId: {
        defaultValue:
            this.props.instanceTemplate?.infrastructureId || null,
        initValid: true,
        rule: ValidationHelper.isOptionalID
      },
      softwareCatalogs: {
        defaultValue: [],
        initValid: true,
        rule: ValidationHelper.isSoftwareCatalogsArray
      },
      isPublished: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      hasInternalLogin: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      configuration: {
        defaultValue: this.getPlaceholderConfiguration(),
        initValid: true,
        rule: ValidationHelper.isNonEmptyString
      },
      tags: {
        defaultValue: [],
        initValid: false,
        rule: ValidationHelper.isStringArray
      },
      type: {
        defaultValue: 0,
        initValid: true,
        rule: ValidationHelper.isInt
      }
    };


    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
      configurationTemplates: []
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  getPlaceholderConfiguration() {
    return "";
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  handleChange(event) {
    if (event.target.name === "type"){
      const configurationTemplates = Object.keys(this.props.configurationTemplates).length > 0 ?
          this.props.configurationTemplates[event.target.value].map(c => ({
            name: c.name,
            value: c.conf
          })) : [];
      this.setState({
        configurationTemplates,
        validation: ValidationHelper.update(event, this.state.validation)
      }, () => {
        this.handleChange({
          target: {
            name: "configuration",
            value: this.props.configurationTemplates[event.target.value][0].conf
          }
        });
      });
    }else{
      this.setState({
        validation: ValidationHelper.update(event, this.state.validation)
      });
    }
  }

  componentDidMount() {
    const configurationTemplates = Object.keys(this.props.configurationTemplates).length > 0 ?
        this.props.configurationTemplates[0].map(c => ({
          name: c.name,
          value: c.conf
        })) : [];
    this.setState({
      configurationTemplates
    });
  }


  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.show !== this.props.show) {
      if (typeof this.props.configurationTemplates[0][0].conf !== "undefined"){
        this.validationDefinition.configuration["defaultValue"] = this.props.configurationTemplates[0][0].conf;
      }
      const configurationTemplates = Object.keys(this.props.configurationTemplates).length > 0 ?
          this.props.configurationTemplates[this.state.validation.type.value].map(c => ({
            name: c.name,
            value: c.conf
          })) : [];
      this.setState({
        configurationTemplates,
        validation: ValidationHelper.getValidation(this.validationDefinition),
      });
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  render() {
    const { t } = this.props;
    const templateTypes = [
      {
        name: t("InstanceTemplates.Modal.Form.TypeLabels.VirtualComputer"),
        value: 0
      },
      {
        name: t("InstanceTemplates.Modal.Form.TypeLabels.Browser"),
        value: 1
      }
    ];

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={this.props.title}
        rightButtonText={t("InstanceTemplates.Modal.Form.Submit")}
        rightButtonIsLoading={this.props.isSaving}
        leftButtonText={t("DialogCancel")}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonCallback={this.onHide}
        dialogApiError={this.props.dialogApiError}
        rightButtonDisabled={!this.state.validation._isValid}
        body={(<div>
          {this.props.validationResult ? (
            <Alert variant="danger">
              <ul>
                {this.props.validationResult
                  .split("Error:")
                  .map((err, index) => (err ? <li key={index}>{err}</li> : ""))}
              </ul>
            </Alert>
          ) : (
            ""
          )}
          <Form onSubmit={this.onSubmit}>
            <Accordion defaultActiveKey="0">
              <Card>
                <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    className="acc-link"
                    eventKey="0"
                  >
                    <FontAwesomeIcon
                      icon={faExclamationCircle}
                      className={
                        this.state.validation.name.isValid &&
                        this.state.validation.tags.isValid &&
                        this.state.validation.isPublished
                          ? "display-none"
                          : "mr-2 color-red"
                      }
                    />
                    <span>{t("InstanceTemplates.Modal.Form.ToggleBasic")}</span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="0">
                  <Card.Body>
                    <Form.Group controlId="formInstanceTemplateName">
                      <Form.Label>
                        {t("InstanceTemplates.Modal.Form.InstanceTemplateName")}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder={t(
                          "InstanceTemplates.Modal.Form.InstanceTemplateNamePlaceholder"
                        )}
                        value={this.state.validation.name.value}
                        isInvalid={!this.state.validation.name.isValid}
                        onChange={this.handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t("InstanceTemplates.Modal.Form.ValidationError.Name")}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formSwitchIsPublished">
                      <Switch
                        className="isPublishedSwitch"
                        onColor="#54BF8D"
                        checked={this.state.validation.isPublished.value}
                        onChange={state => {
                          this.handleChange({
                            target: {
                              name: "isPublished",
                              value: state
                            }
                          });
                        }}
                        height={18}
                        width={40}
                      />
                      <Form.Label>
                        {t("InstanceTemplates.Modal.Form.IsPublished")}
                      </Form.Label>
                      <Form.Control
                        type="hidden"
                        isInvalid={!this.state.validation.isPublished.isValid}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                          "InstanceTemplates.Modal.Form.ValidationError.IsPublished"
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formSwitchHasInternalLogin">
                      <Switch
                          className="isPublishedSwitch"
                          onColor="#54BF8D"
                          checked={this.state.validation.hasInternalLogin.value}
                          onChange={state => {
                            this.handleChange({
                              target: {
                                name: "hasInternalLogin",
                                value: state
                              }
                            });
                          }}
                          height={18}
                          width={40}
                      />
                      <Form.Label>
                        {t("InstanceTemplates.Modal.Form.HasInternalLogin")}
                      </Form.Label>
                      <Form.Control
                          type="hidden"
                          isInvalid={!this.state.validation.hasInternalLogin.isValid}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                            "InstanceTemplates.Modal.Form.ValidationError.HasInternalLogin"
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formSelectType">
                      <Form.Label>
                        {t("InstanceTemplates.Modal.Form.Type")}
                      </Form.Label>
                      <BaseSelect
                        options={templateTypes}
                        onChange={s => {
                          this.handleChange({
                            target: {
                              name: "type",
                              value: s.value
                            }
                          });
                        }}
                        getOptionLabel={option => option.name}
                        getOptionValue={option => option.value}
                        value={templateTypes[this.state.validation.type.value]}
                      />
                      <Form.Control
                        type="hidden"
                        isInvalid={!this.state.validation.type.isValid}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t("InstanceTemplates.Modal.Form.ValidationError.Type")}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formSelectPreferredNetworkProfile">
                      <Form.Label>
                        {t(
                          "InstanceTemplates.Modal.Form.PreferredNetworkProfile"
                        )}
                      </Form.Label>
                      <BaseSelect
                        options={this.props.networkProfiles}
                        onChange={s => {
                          this.handleChange({
                            target: {
                              name: "preferredNetworkProfile",
                              value: s?._id
                            }
                          });
                        }}
                        getOptionLabel={option => option.name}
                        getOptionValue={option => option._id}
                        placeholder={t(
                          "InstanceTemplates.Modal.Form.PreferredNetworkProfilePlaceholder"
                        )}
                        backspaceRemovesValue={true}
                        escapeClearsValue={true}
                        isClearable={true}
                        value={this.props.networkProfiles
                          .filter(
                            o =>
                              o._id ===
                              this.state.validation.preferredNetworkProfile
                                .value
                          )
                          .shift()}
                      />
                      <Form.Control
                        type="hidden"
                        isInvalid={
                          !this.state.validation.preferredNetworkProfile.isValid
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                          "InstanceTemplates.Modal.Form.ValidationError.NetworkProfile"
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formSelectSoftwareCatalogs">
                      <Form.Label>
                        {t("InstanceTemplates.Modal.Form.SoftwareCatalogs")}
                      </Form.Label>
                      <BaseSelect
                        options={this.props.softwareCatalogs}
                        isMulti={true}
                        onChange={s => {
                          this.handleChange({
                            target: {
                              name: "softwareCatalogs",
                              value: s || []
                            }
                          });
                        }}
                        getOptionLabel={option => option.name}
                        getOptionValue={option => option._id}
                        placeholder={t(
                          "InstanceTemplates.Modal.Form.SoftwareCatalogsPlaceholder"
                        )}
                        value={this.state.validation.softwareCatalogs.value}
                      />
                      <Form.Control
                        type="hidden"
                        isInvalid={
                          !this.state.validation.softwareCatalogs.isValid
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                          "InstanceTemplates.Modal.Form.ValidationError.SoftwareCatalogs"
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group controlId="formSelectTags">
                      <Form.Label>
                        {t("InstanceTemplates.Modal.Form.Tags")}
                      </Form.Label>
                      <TagSelection
                        onChange={tags =>
                          this.handleChange({
                            target: {
                              name: "tags",
                              value: tags || []
                            }
                          })
                        }
                        max={50}
                        selectedTags={this.state.validation.tags.value}
                        placeholder={t(
                          "InstanceTemplates.Modal.Form.TagsPlaceholder"
                        )}
                        className="mb-3"
                      />
                      <Form.Control
                        type="hidden"
                        isInvalid={!this.state.validation.tags.isValid}
                      />
                      <small>
                        {t("InstanceTemplates.Modal.Form.TagsHint")}
                      </small>
                      <Form.Control.Feedback type="invalid">
                        {t("InstanceTemplates.Modal.Form.ValidationError.Tags")}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    className="acc-link"
                    eventKey="1"
                  >
                    <FontAwesomeIcon
                      icon={faExclamationCircle}
                      className={
                        this.state.validation.description.isValid
                          ? "display-none"
                          : "mr-2 color-red"
                      }
                    />
                    <span>{t("InstanceTemplates.Modal.Form.Description")}</span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    <Form.Group>
                      <MarkDownEditor
                        defaultValue={this.props.instanceTemplate ? this.props.instanceTemplate.description :
                        ValidationHelper.getDefaultValueExtendedDescription()}
                        onChange={value =>
                          this.handleChange({
                            target: {
                              name: "description",
                              value: value
                            }
                          })
                        }
                      />
                      <Form.Control
                        type="hidden"
                        isInvalid={!this.state.validation.description.isValid}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t(
                          "InstanceTemplates.Modal.Form.ValidationError.Description"
                        )}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card>
                <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    className="acc-link"
                    eventKey="2"
                  >
                    <FontAwesomeIcon
                      icon={faExclamationCircle}
                      className={
                        this.state.validation.configuration.isValid
                          ? "display-none"
                          : "mr-2 color-red"
                      }
                    />
                    <span>
                      {t("InstanceTemplates.Modal.Form.Configuration")}
                    </span>
                  </Accordion.Toggle>
                </Card.Header>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    <Form.Group controlId="formSelectType">
                      <Form.Label>
                        {t("InstanceTemplates.Modal.Form.Configuration")}
                      </Form.Label>
                      <BaseSelect
                          options={this.state.configurationTemplates}
                          onChange={s => {
                            this.handleChange({
                              target: {
                                name: "configuration",
                                value: s.value
                              }
                            });
                          }}
                          value={this.state.configurationTemplates.filter(o => o.value === this.state.validation.configuration.value)[0]}
                          getOptionLabel={option => option.name}
                          getOptionValue={option => option.value}
                      />
                      <Form.Control
                          type="hidden"
                          isInvalid={!this.state.validation.configuration.isValid}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t("InstanceTemplates.Modal.Form.ValidationError.Configuration")}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </Form>
        </div>)}
      />
    );
  }
}

export default withTranslation()(InstanceTemplateDialog);
